import { render, staticRenderFns } from "./AssetBuilder.vue?vue&type=template&id=1c550fee&"
import script from "./AssetBuilder.vue?vue&type=script&lang=js&"
export * from "./AssetBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AssetBuilder.vue"
export default component.exports